import React, {Fragment, useEffect, useState} from "react";
import {Container, Grid} from "@mui/material";
import CardTripAccordion from "../components/Availability/CardTripAccordion.js";
import {useLocation, useHistory} from "react-router-dom";
import {registerFindTrip, newRequestApi} from "../utils/utils.js";
import {TripPropTypes} from "../utils/PropTypes/TripPropTypes.js";
import CardTripAccordionLoader from "../components/Availability/CardTripAccordionLoader.js";
import SearchFilterAccordion from "../components/Availability/SearchFilterAccordeon.js";

const AvailabilityPageNew = () => {
    const location = useLocation();
    const history = useHistory();
    const [searchForm, setSearchForm] = useState({
        destination: "",
        destinationId: '',
        adventure: '',
        location: "",
        year: "",
        month: "",
        space: "",
        hideUnavailable: true,
        onlyDealerTrips: false,
    });
    const [destinations, setDestinations] = useState([]);
    const [destinationsFilter, setDestinationsFilter] = useState([]);
    const [adventures, setAdventures] = useState([]);
    const [ships, setShips] = useState([]);
    const [paginator, setPaginator] = useState({
        page: 1,
        query: {},
        lastPage: 1,
    });
    const [loading, setLoading] = React.useState(true);

    // Function to parse the boolean values of the URL
    const parseUrlValue = (value) => {
        if (value === 'true') return true;
        if (value === 'false') return false;
        return value;
    };

    // Function to get the filters from the URL
    const getFiltersFromUrl = () => {
        const searchParams = new URLSearchParams(location.search);
        const urlFilters = {};
        searchParams.forEach((value, key) => {
            urlFilters[key] = parseUrlValue(value);
        });
        return urlFilters;
    };

    // Function to update the filters
    const updateFilters = (newFilters) => {
        setSearchForm(prevState => {
            const updatedForm = {
                ...prevState,
                ...newFilters
            };
            // Update URL
            const searchParams = new URLSearchParams();
            // Only include in the URL the values that are not the default values
            Object.entries(updatedForm).forEach(([key, value]) => {
                // Omit hideUnavailable if it's true
                if (key === 'hideUnavailable' && value === true) return;
                if (key === 'onlyDealerTrips' && value === false) return;

                // For the rest of the fields, only include if they have a value
                if (value !== "" && value !== null && value !== undefined) {
                    searchParams.set(key, value);
                }
            });
            // Build the URL with only the necessary parameters
            const queryString = searchParams.toString() ? `?${searchParams.toString()}` : '';
            const newUrl = `${queryString}`;
            if (newUrl !== `${location.search}`)
                history.push(newUrl);
            return updatedForm;
        });
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                // Get filters from the URL and update the state
                const urlFilters = getFiltersFromUrl();
                updateFilters(urlFilters);

                await getDestinations();
                await fetchAdventures();
                await fetchShips();
                registerFindTrip();
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [location.search]); // Listen changes in location.search

    const getDestinations = async (params = {}) => {
        const filteredKeys = Object.keys(params).filter(k => params[k]);
        const filteredParams = {};

        // If there are no parameters in the URL, do not try to process them
        if (location.search.toString()) {
            for (const [key, value] of new URLSearchParams(location.search)) {
                filteredParams[key] = value;
            }
        }

        // Overwrite query params with select if any
        for (let key of filteredKeys) {
            filteredParams[key] = params[key];
        }

        const preloader = false;
        let page = 1;
        // Ensure there is always a query, even if it is empty
        let query = {...filteredParams, page};
        
        try {
            const {data} = await newRequestApi("get-destination-list", "GET", query, null, preloader);
            if (data.status === "success") {
                setDestinations(data.data);
                setDestinationsFilter(data.data);
                setPaginator({...paginator, page, query});
            }
        } catch (error) {
            console.error("Error fetching destinations:", error);
            // In case of error, set empty arrays to avoid undefined
            setDestinations([]);
            setDestinationsFilter([]);
        }
    };

    const fetchAdventures = async (preloader = false) => {
        const {data} = await newRequestApi('get-adventures', "GET", null, null, preloader);
        if (data.status === 'success')
            setAdventures(data.data);
    };

    const fetchShips = async (preloader = false) => {
        const {data} = await newRequestApi("get-ships", "GET", null, null, preloader);
        if (data.status === "success") setShips(data.data);
    };

    // useEffect(() => {
    // 	if (searchForm.destinationId !== '' && searchForm.destination === parseInt(searchForm.destinationId)) {
    // 		const filterByDestination = destinations.map(destination => ({
    // 			...destination,
    // 			destinations: destination.destinations.filter(dd => dd.tripClassId === searchForm.destination)
    // 		}));
    // 		setDestinationsFilter(filterByDestination);
    // 	} else if (searchForm.destination !== '' && destinations.length > 0) {
    // 		const filterByDestination = destinations.filter(destination => destination.id === parseInt(searchForm.destination));
    // 		setDestinationsFilter(filterByDestination);
    // 	}
    // 	else if(searchForm.destination==='' && searchForm.destinationId === '')
    // 		setDestinationsFilter(destinations);
    // }, [searchForm.destination, searchForm.destinationId]);


    return (
        <>
            <Container maxWidth="lg" sx={{padding: "0 1.6rem !important"}}>
                <Grid container spacing={4} style={{paddingTop: 40}}>
                    <Grid
                        item
                        xs={12}
                        md={9}
                        order={{xs: 2, md: 1}}
                        sx={{marginTop: 0}}
                    >
                        {loading &&
                            <Fragment>
                                <CardTripAccordionLoader preloaderIcon/>
                                <CardTripAccordionLoader preloaderIcon/>
                                <CardTripAccordionLoader preloaderIcon/>
                            </Fragment>}
                        {destinationsFilter.length > 0 &&
                            destinationsFilter.map((d) => (
                                d.destinations.length > 0 && d.destinations.map((dd) => (
                                    <CardTripAccordion
                                        key={dd.tripClassId}
                                        destinationId={d.id}
                                        tripClass={dd}
                                        searchForm={searchForm}
                                    />
                                ))
                            ))
                        }
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        md={3}
                        order={{xs: 1, md: 2}}
                        style={{
                            paddingBottom: 50,
                            "@media (maxWidth: 1024px)": {
                                paddingBottom: 0,
                            },
                        }}
                    >
                        <SearchFilterAccordion
                            searchForm={searchForm}
                            setSearchForm={updateFilters}
                            destinations={destinations}
                            adventures={adventures}
                            ships={ships}
                        />
                    </Grid>
                </Grid>
            </Container>
        </>
    );
};

export default AvailabilityPageNew;

AvailabilityPageNew.propTypes = {
    trip: TripPropTypes,
};